module.exports = __webpack_public_path__ + "img/active-directory.dd9e7a5d.svg";